// Formulář sem hlásí, jestli v něm uživatel něco má. Podle toho se nová verze
// aplikace buď načte sama, nebo se jen nabídne tlačítkem (viz App.vue).

const state = {
    hasUserData: false
}

const mutations = {

    setHasUserData(state, hasUserData) {
        state.hasUserData = !!hasUserData;
    }
}

export const form = {
    namespaced: true,
    state,
    mutations
};
